export const locale = {
    lang: 'zh1',
    data: {
      'EDITOR': {
        'CARGANDO': '加載信息',
        'GUARDANDO': '保存更改',
        'ELEMENTOS': {
          'GUIA': '該塊的元素',
          'COLORES': {
            'ORIGINAL': '未修改的元素',
            'MODIFICADO': '修改品'
          },
          'TOOLTIPS': {
            'ORIGINAL': '尚未修改任何元素',
            'MODIFICADO': '一個或多個項目已被修改',
            'COMPLETO': '所有元素均已修改',
            'AMPLIAR': '查看大圖',
            'ELIMINAR': '刪除這張圖片',
            'IMPORTAR': '從其他語言導入該項目',
            'CONFIGDOMINIO': '後端域配置',
            'COPIARURL': '複製鏈接'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': '經紀人配置',
              'SUBTITULO': '您可以查看和修改每個可用代理的設置',
              'PASOINICIAL': '從列表中選擇一個代理以顯示其配置',
              'SELBROKER': '選定經紀人',
              'SELOPC': '選擇的選項',
              'SINJSONS': '無法從該經紀人加載信息，請稍後再試',
              'DOMINIO': {
                'TITULO': '代理後端域配置',
                'ACTIVAR': '激活與代理關聯的域',
                'DOMINIO': '與經紀人關聯的域'
              },
              'MODAL': {
                'TITULO': '導入元素',
                'SUBTITULO': '選擇您要從中導入此項目的語言'
              }
            },
            'IMAGEN': {
              'NOHAY': '沒有圖像',
              'ACTUAL': '當前圖像'
            },
            'TEXTO': {
              'INGRESAR': '輸入你的文字'
            },
            'VIDEO': {
              'NOVIDEO': '您尚未上傳視頻',
              'GUARDANDO': '正在保存視頻，請在完成上傳之前退出此屏幕'
            }
          },
          'BOTONES': {
            'ENTRAR': '編輯調查特徵',
            'REGRESAR': '回去',
            'CONTINUAR': '繼續',
            'CANCELAR': '取消',
            'GUARDAR': '保存更改',
            'IMAGEN': '變更圖片',
            'EDITOR': '編輯訊息',
            'ELEMENTOS': '幫助',
            'ACTIVAR': '表演',
            'DESACTIVAR': '隱藏',
            'VERVIDEO': '看視頻',
            'CARGARVIDEO': '上傳視頻文件',
            'OTROVIDEO': '上載另一個視頻文件',
            'SI': '是的',
            'NO': '不',
            'INFO': '重要的',
            'ADDIMG': '添加圖片'
          },
          'MODALIMAGEN': {
            'TITULO': '將圖片添加到消息',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': '指示',
                'PASO_1': '點擊\'圖片\'標籤，您可以選擇已經上傳的圖片，也可以上傳新圖片',
                'PASO_2': '如果您想選擇已上傳的圖片，將光標放在所需的圖片上，您可以執行兩種操作：查看圖片或複制鏈接',
                'PASO_2_1': '要預覽，請單擊圖像上帶有以下圖標的按鈕',
                'PASO_2_2': '要復制鏈接，請單擊帶有以下圖標的圖像上的按鈕',
                'PASO_3': '如果要上傳新圖片，請單擊帶有以下圖標的按鈕',
                'PASO_4': '當你上傳完圖片後，你會自動得到它的鏈接',
                'PASO_5': '返回消息編輯器，點擊按鈕插入圖片，圖標如下',
                'PASO_6': '在彈出窗口中放置複製的鏈接並設置圖像大小，以像素表示。完成後，單擊“保存”按鈕。彈出窗口將關閉，圖像將被放置在具有設置大小的編輯器中'
              },
              'IMAGENES': {
                'TITULO': '圖片',
                'CARGANDO': '加載可用圖像',
                'NOTA': '* 此處顯示的圖像保存在文件管理器中',
                'TITULO_2': '可用圖像',
                'ADD': '添加新圖像',
                'NOIMG': '沒有可用的圖像',
                'URLCOPIADA': '圖片鏈接已復製到剪貼板',
                'OKBOT': '好的'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': '顏色設置1',
            'theme-temaIzzi': '彩色套裝2',
            'theme-blue-gray-dark': '彩色套裝3',
            'theme-pink-dark': '顏色設置4',
            'theme-temaIzzi-2': '顏色設置5',
            'theme-temaItbm': '顏色設置6',
          },
          'numColumnas': {
            '1': '1列',
            '4': '4列',
            '5': '5列',
          },
          'segundos': {
            '1000': '1秒',
            '2000': '2秒',
            '3000': '3秒',
            '4000': '4秒',
            '5000': '5秒',
            '6000': '6秒',
            '7000': '7秒',
            '8000': '8秒',
            '9000': '9秒',
            '10000': '10秒',
            '11000': '11秒',
            '12000': '12秒',
            '13000': '13秒',
            '14000': '14秒',
            '15000': '15秒',
            '16000': '16秒',
            '17000': '17秒',
            '18000': '18秒',
            '19000': '19秒',
            '20000': '20秒',
          },
          'logosIniciales': {
            '0': 'CulturalGO徽標'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': '警告：如果源站點不允許從外部站點訪問頁面，則不會顯示內容',
          'TEMPLATEFALTANTE': '警告：此模板不適用於該語言',
          'CONFIGURACION': {
            'ACTIVAR': '警告：激活自定義配置時，此屏幕上指定的所有項目都將放置在平台界面中，請確保您已放置所有正確的項目\n\n是否要繼續並激活自定義配置？',
            'DESACTIVAR': '警告：停用自定義配置時，將放置在平台中為此代理程序以及所有屬於該代理程序的用戶建立的默認元素。\n\n是否要繼續並停用個性化配置？ '
          },
          'PRIORIDAD': {
            '1': '如果此元素處於活動狀態，則將優先於背景圖像',
            '2': '如果此元素處於活動狀態，則將優先於背景圖像和視頻背景。'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': '登錄',
            'PASOS': {
              'VARIOS': {
                'TITULO': '雜件',
                'ELEMENTOS': {
                  'images_broker': '經紀人徽標',
                  'title': '主題',
                  'images_login': '系統徽標',
                  'images_logout': '註銷時顯示的圖像',
                  'changeTime': '圖像之間的時間間隔'
                }
              },
              'BACKGROUNDS': {
                'TITULO': '背景圖片',
                'ELEMENTOS': {
                  'agregar': '新增圖片',
                  'importar': '從其他設置導入圖像',
                }
              },
              'VIDEO': {
                'TITULO': '背景視頻',
                'ELEMENTOS': {
                  'enable': '啟用背景視頻',
                  'video': '要顯示的視頻',
                  'loop': '啟用自動重複',
                  'mute': '顯示靜音的視頻'
                }
              },
              'EXTERNO': {
                'TITULO': '外部內容',
                'ELEMENTOS': {
                  'enable': '啟用外部內容',
                  'url': '外部內容鏈接顯示',
                }
              }
            }
          },
          'HOME': {
            'TITULO': '主頁',
            'PASOS': {
              'BRAND':{
                'TITULO': '側面菜單中的系統ID',
                'ELEMENTOS': {
                  'logo': '系統徽標',
                  'name': '系統名稱'
                }
              },
              'LOGOINICIAL': {
                'TITULO': '初始徽標',
                'ELEMENTOS': {
                  'show': '顯示初始系統徽標',
                  'time': '徽標顯示時間（以秒為單位）',
                  'type': '要顯示的初始徽標類型'
                }
              },
              'MOSAICO': {
                'TITULO': '圖像拼接',
                'ELEMENTOS': {
                  'branding_show': '顯示系統品牌徽標',
                  'branding_image': '系統品牌徽標',
                  'grayFilter': '啟動圖像上的灰色濾鏡',
                  'bgGridColumns': '要顯示的圖像列數'
                }
              },
              'TEMAS': {
                'TITULO': '平台顏色主題',
                'ELEMENTOS': {
                  'theme': '在系統中顯示的顏色主題'
                }
              },
              'BACKGROUNDS': {
                'TITULO': '背景圖片',
                'ELEMENTOS': {
                  'agregar': '新增圖片',
                  'importar': '從其他設置導入圖像',
                }
              },
              'VIDEO': {
                'TITULO': '背景視頻',
                'ELEMENTOS': {
                  'enable': '啟用背景視頻',
                  'video': '要顯示的視頻',
                  'loop': '啟用自動重複',
                  'mute': '顯示靜音的視頻'
                }
              },
              'EXTERNO': {
                'TITULO': '外部內容',
                'ELEMENTOS': {
                  'enable': '啟用外部內容',
                  'url': '外部內容鏈接顯示',
                }
              },
              'LOADER': {
                'TITULO': '圖片 .gif 加載',
                'ELEMENTOS': {
                  'image': '圖片加載.gif',
                  'GUARDANDO': '正在保存圖像，加載完成前不要退出此屏幕'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': '電子郵件範本',
            'PASOS': {
              'RT_1': {
                'TITULO': '技術要求，在註冊新產品時發送',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
              'RT_2': {
                'TITULO': '技術要求，驗證期間發送的演示消息',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
              'PASS_3': {
                'TITULO': '更新用戶密碼時發送的郵件',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
              'PASS_4': {
                'TITULO': '更新用戶個人資料時發送的電子郵件',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
              'GETMYCODE_6': {
                'TITULO': '使用 GetMyCode 發送的郵件',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
              'RT_7': {
                'TITULO': '技術要求驗收郵件',
                'ELEMENTOS': {
                  'asunto': '郵件主題',
                  'mensaje': '郵件正文'
                }
              },
            }
          }
        }
      }
    }
};
